/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FantaGroup } from '../models/FantaGroup';
import type { FantaGroupCreate } from '../models/FantaGroupCreate';
import type { FantaGroupPatch } from '../models/FantaGroupPatch';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FantaGroupService {
    /**
     * Get My Fanta Groups
     * @returns FantaGroup Successful Response
     * @throws ApiError
     */
    public static getMyFantaGroups(): CancelablePromise<Array<FantaGroup>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_group/my',
        });
    }
    /**
     * Get Fanta Group
     * @param fantaGroupId
     * @returns FantaGroup Successful Response
     * @throws ApiError
     */
    public static getFantaGroup(
        fantaGroupId: number,
    ): CancelablePromise<FantaGroup> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/fanta_group/{fanta_group_id}',
            path: {
                'fanta_group_id': fantaGroupId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Fanta Group
     * @param fantaGroupId
     * @param requestBody
     * @returns FantaGroup Successful Response
     * @throws ApiError
     */
    public static patchFantaGroup(
        fantaGroupId: number,
        requestBody: FantaGroupPatch,
    ): CancelablePromise<FantaGroup> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/fanta_group/{fanta_group_id}',
            path: {
                'fanta_group_id': fantaGroupId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Fanta Group
     * @param fantaGroupId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteFantaGroup(
        fantaGroupId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/fanta_group/{fanta_group_id}',
            path: {
                'fanta_group_id': fantaGroupId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Fanta Group
     * @param requestBody
     * @returns FantaGroup Successful Response
     * @throws ApiError
     */
    public static createFantaGroup(
        requestBody: FantaGroupCreate,
    ): CancelablePromise<FantaGroup> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_group/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Join Fanta Group
     * @param fantaGroupId
     * @param fantaTeamId
     * @returns FantaGroup Successful Response
     * @throws ApiError
     */
    public static joinFantaGroup(
        fantaGroupId: number,
        fantaTeamId: number,
    ): CancelablePromise<FantaGroup> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/fanta_group/group/{fanta_group_id}',
            path: {
                'fanta_group_id': fantaGroupId,
            },
            query: {
                'fanta_team_id': fantaTeamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Leave Fanta Group
     * @param fantaGroupId
     * @param fantaTeamId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static leaveFantaGroup(
        fantaGroupId: number,
        fantaTeamId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/fanta_group/team/{fanta_group_id}',
            path: {
                'fanta_group_id': fantaGroupId,
            },
            query: {
                'fanta_team_id': fantaTeamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
